<div class="home-container">
  <app-hero-image  [style.minHeight.px]="height" (getImgHeight)="getImgHeight($event)"  [nestled]="widgetOnHero" class="hero-img-home" [class.nestled-img-js]="widgetOnHero" [src]="heroImageUrl"></app-hero-image>
  <div [class.nestled-js]="widgetOnHero" class="row widget-container">
    <app-widget (getWidgetHeight)="getWidgetHeight($event)" id="widget" class="col-md-8"
      [showQuoteTab]="showQuoteTab"
      [showPolicyTab]="showPolicyTab"
      [showClaimTab]="showClaimTab"
      [nonActiveTabColor]="nonActiveTabColor"
      [tabHoverColor]="tabHoverColor"
      [quoteButtonText]="quoteButtonText"
      [quoteButtonColor]="quoteButtonColor"
      [quoteButtonHoverColor]="quoteButtonHoverColor"
      [quoteWidgetSelection]="quoteWidgetSelection"
      [destinationSelection]="destinationSelection"
      [quoteTabCaption]="quoteTabCaption"
    ></app-widget>
    @if (!widgetOnHero) {
      <div [class.col-md-4]="!widgetOnHero"  class="content-container--why-buy d-flex right-of-widget">
        @if (firstContentBlock | async; as cb) {
          <app-content-block [content]="cb"></app-content-block>
        }
      </div>
    }

  </div>
  @if (widgetOnHero) {
    <div [class.col-md-12]="widgetOnHero" class="content-container--why-buy d-flex align-items-center">
      @if (firstContentBlock | async; as cb) {
        <app-content-block [content]="cb"></app-content-block>
      }
    </div>
  }
  <div class="row">
    @if (contentBlocks | async; as cbs) {
      <app-content-block-container class="col-12" [maxBlocks]="MAX_BLOCKS" [contentBlocks]="cbs">
      </app-content-block-container>
    }
  </div>
</div>
